module.exports = __webpack_public_path__ + "img/33.4b879f8b.jpg";